var _style, _linearGradient, _path, _linearGradient2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetropolitan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    width: 652,
    height: 200,
    viewBox: "-153 -46 652 200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#002856;}\n")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 5133.8,
    x2: 5133.8,
    y1: 201.2,
    y2: 358.44,
    gradientTransform: "rotate(180 2517.6 166.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002856",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002A5E",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003075",
    offset: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A9A",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003DA7",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7DCE",
    offset: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-91.588 72.558-13.4-23.1 42.5-74.5v124.3c-0.4 5.1-2.5 9.8-5.9 13.6-5.4 5-11 8.8-34.3 13.2l-32 6.1 13.1-28.9c6.5-0.4 12.9-1.7 19-3.7 8.2-3 15.3-5.4 21.9-13.4s7.2-26.9 8.3-39.4c1.1-12.4 0.5-9.7 0.5-9.7z",
    fill: "url(#SVGID_1_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 5057,
    x2: 5057,
    y1: 201.2,
    y2: 358.44,
    gradientTransform: "rotate(180 2517.6 166.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002856",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002A5E",
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003075",
    offset: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A9A",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003DA7",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7DCE",
    offset: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF",
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-28.988 72.558 13.4-23.1-42.3-74.5v124.3c0.4 5.1 2.5 9.8 5.9 13.6 5.4 5 11 8.8 34.3 13.2l32 6.1-13.3-29c-6.4-0.4-12.8-1.6-18.9-3.6-8-3-15.3-5.4-21.8-13.4s-7.2-26.9-8.3-39.4c-1.1-12.4-0.6-9.7-0.6-9.7z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m410.41 59.358-4 11.4h8zm-8.7 24.4h-4.6l12.7-34.4h4.6l12.3 34.4h-7.8l-3.2-9.5h-10.6zm-349.5 0v-26.8l-10.6 18.4-10.6-18.4v26.8h-4.2v-34.5h8.1l8.7 14.9 8.7-14.9h7.3v34.5zm31.8-20.1h10v3.6h-10.1v13h13.8v3.6h-21.1v-34.5h21.2v3.6h-13.8zm40.5-10.8v30.9h-7.4v-30.9h-9.8v-3.6h27v3.6zm32.6 0.1h-2.6v11.7h2.6c3.2-0.2 5.7-2.9 5.6-6.1-0.1-3.1-2.6-5.6-5.6-5.6m-10.1 30.8v-34.4h10c6.4 0 13.8 2.8 13.8 9.2-0.2 3.9-2.9 7.3-6.7 8.4l9.6 16.9h-8.6l-8-15.6h-2.5v15.6h-7.6zm44-17.2c0 6.5 1.2 14.6 7.6 14.6s7.6-8 7.6-14.6-1.2-14.7-7.6-14.7c-6.5 0-7.6 8-7.6 14.7m7.6 18.4c-9.5-0.5-16.8-8.6-16.2-18.1v-0.1c-1-9 5.5-17.1 14.5-18.1s17.1 5.5 18.1 14.5c0.1 1.2 0.1 2.4 0 3.6 0.6 9.5-6.7 17.6-16.1 18.2-0.2-0.1-0.2 0-0.3 0m37.2-18.9h4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6h-4zm0 17.7h-7.4v-34.4h11.3c6.9 0 14.5 3.3 14.5 10.2 0 6.8-7.6 10.2-14.5 10.2h-4v14.1h0.1zm36.6-17.2c0 6.5 1.2 14.6 7.6 14.6s7.6-8 7.6-14.6-1.2-14.7-7.6-14.7-7.6 8-7.6 14.7m7.6 18.2c-9.5-0.5-16.8-8.6-16.2-18.1v-0.1c-1.1-9 5.3-17.1 14.3-18.2s17.1 5.3 18.2 14.3c0.2 1.3 0.2 2.6 0 4 0.7 9.5-6.5 17.7-15.9 18.4h-0.3m29.7-35.8h7.4v30.9h13.3v3.6h-20.7v-30.8zm41.1 0v34.5h-7.5v-34.5zm30.4 3.6v30.9h-7.4v-30.9h-9.7v-3.6h27v3.6zm84-3.6v35.5l-20.8-26.2v25.2h-4.2v-34.5h6.1l14.8 17.6v-17.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetropolitan);
export default __webpack_public_path__ + "static/media/metropolitan.ba7f54d6bf1f5557859f9b6399545a5f.svg";
export { ForwardRef as ReactComponent };